module.exports = __webpack_public_path__ + "static/media/checked.779b9dc3.gif";